import { createCodebookCache } from '../utils/codebookCache';

// ─── Subprocess cache (via shared codebook-cache factory) ───────────────────
// SWR + subscriber broadcast + auto-invalidate on writes to /api/subprocesses.
// The broadcast is what makes a reorder on /subprocesses show up immediately in
// the kept-alive /os stage tree (order + group order come from the populated
// processDefinition on each subprocess) without a full page refresh.

export interface SubprocessOption {
  _id: string;
  name?: string;
  machines?: Array<{ machine: string | { _id: string; code?: string; name?: string; status?: boolean }; order?: number | string | null }>;
  inProcess?: Array<{ _id: string; text: string; frequency?: number | string | null; unit?: string | { _id: string; code?: string; name?: string } | null }>;
  montageParams?: Array<{ _id: string; text: string }>;
  instructions?: Array<{ _id: string; text: string }>;
  statuses?: Array<{ _id?: string; name: string; description?: string }>;
  order?: number;
  operatorCount?: number | null;
  processDefinition?: { _id: string; code?: string; name?: string; status?: string; order?: number } | string | null;
}

// /active returns the WHOLE list (it used to be capped at 200 — the stage tree would silently
// lose every subprocess past that) and is open to every module that shows subprocesses.
const subprocessCache = createCodebookCache<SubprocessOption>({
  endpoint: '/api/subprocesses/active',
  invalidateOn: '/api/subprocesses',
  select: (data) => (Array.isArray(data) ? data : []),
});

/** Call after any successful create/update/delete so next mount fetches fresh data. */
export const invalidateSubprocessCache = subprocessCache.invalidate;

export const useSubprocesses = (): SubprocessOption[] => subprocessCache.useOptions();
